import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { RootState } from 'store';
import { ImportSessionStorage } from 'utils/importSessionStorage';

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  // In cookie mode, check for user data instead of token
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = token || user;

  useEffect(() => {
    if (!isAuthenticated) {
      // Preserve the intended destination (e.g. a /settings/partners deep
      // link) so AuthRoute returns the user there after login instead of
      // the /home default.
      //
      // First intent wins: a signed-out visitor who deep-links somewhere and
      // then touches another protected route before authenticating (opening
      // /home in a tab, pressing back) must still land on the page they asked
      // for. Only store when nothing is stored. The explicit writers
      // (ViewCard, UniversalImport, EternalDurdles, AffiliatesLanding) stay
      // unconditional on purpose: a deliberate click should beat a bounce.
      if (!ImportSessionStorage.getReturnTo()) {
        ImportSessionStorage.setReturnTo(location.pathname + location.search);
      }
      navigate('/welcome', { replace: true });
    }
  }, [isAuthenticated, navigate, location.pathname, location.search]);

  return <>{children}</>;
};

export default ProtectedRoute;
